export default function () {
    const options = {
        name: 'device',
        template: 'templates/device-locking.html',
        data() {
            return {
                show: true,
            };
        },
        mounted() {
            const context = this;
            const im = this.$im();
            const messageApi = this.RongIM.dataModel.Message;
            context.messageWatch = function messageWatch(message) {
                if (message.messageType === 'MultiClientMessage') {
                    if (+message.content.action === 2) {
                        // 解锁
                        context.show = false;
                        im.isLock = false;
                    }
                }
            };
            messageApi.watch(context.messageWatch);
        },
        methods: {
            unlock() {
                const common = this.RongIM.common;
                this.RongIM.dataModel.Device.unlock((errorCode) => {
                    if (errorCode) {
                        common.toastError(errorCode);
                    }
                });
            },
        },
        destroyed() {
            const context = this;
            this.RongIM.dataModel.Message.unwatch(context.messageWatch);
        },
    };
    window.RongIM.common.mountDialog(options);
}
